export enum RouteType {
    PUBLIC = 'public',
    EMPLOYER = 'employer',
    SUPPORT = 'support'
}
